import Image from 'next/image';
import { useRouter } from 'next/router';
import ReactMarkdown from 'react-markdown';
import { TeamMemberBoxStyles } from '../../styles/components/team-members';

export interface ITeamMemberBoxProps {
  fullname: string;
  jobTitle: string;
  biography: string;
  socialMediaIcons: { iconUrl: string; link: string }[];
  imageUrl: string;
  slug: string;
}

const TeamMemberBox = (props: ITeamMemberBoxProps) => {
  const router = useRouter();

  const preventSocialLinkPropagation = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.stopPropagation();
  };

  const goToSlug = () => {
    window.location.href =
      router.locale !== 'en'
        ? `/${router.locale}/${props.slug}`
        : `/${props.slug}`;
  };

  return (
    <div className={TeamMemberBoxStyles['team-member-box']}>
      <div className={TeamMemberBoxStyles['team-member-box-image']}>
        <Image
          src={props.imageUrl}
          alt={`${props.fullname} image`}
          height={360}
          width={360}
        />
      </div>
      <div className={TeamMemberBoxStyles['team-member-box-content']}>
        <div>
          <a
            href={
              router.locale !== 'en'
                ? `/${router.locale}/${props.slug}`
                : `/${props.slug}`
            }>
            {props.fullname}
          </a>
          <p
            className={
              TeamMemberBoxStyles['team-member-box-content-job-title']
            }>
            {props.jobTitle}
          </p>
        </div>
        {props.socialMediaIcons && props.socialMediaIcons.length > 0 && (
          <div
            className={
              TeamMemberBoxStyles['team-member-box-content-social-media']
            }>
            {props.socialMediaIcons.map((icon, index) => (
              <a
                key={index}
                href={icon.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={preventSocialLinkPropagation}>
                <Image
                  src={icon.iconUrl}
                  alt={`Social media icon ${index}`}
                  width={24}
                  height={24}
                />
              </a>
            ))}
          </div>
        )}
        <ReactMarkdown
          className={TeamMemberBoxStyles['team-member-box-content-biography']}>
          {props.biography}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default TeamMemberBox;
